import { StatusBar } from 'expo-status-bar';
import React, { useEffect, useRef, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Dimensions, Image, ImageBackground, StyleSheet, Text, View, Alert, Pressable } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { SafeAreaProvider, useSafeAreaInsets } from 'react-native-safe-area-context';
import { TextInput } from 'react-native-gesture-handler';
import QRCode from 'react-native-qrcode-svg';
// import { Exit } from './exit.svg'
import Svg, { Path } from "react-native-svg"
import { axiosBasicInstanceApiGateway, axiosTokenInstanceApiGateway } from './helpers';
import PasswordInput from './PasswordInput';


const Stack = createNativeStackNavigator();

const {
  width: SCREEN_WIDTH,
  height: SCREEN_HEIGHT,
} = Dimensions.get('window');

console.log(SCREEN_HEIGHT)

const HomeScreen = ({ navigation }) => {

  const [usuario, setUsuario] = useState("")
  const [password, setPassword] = useState("")

  const logout = async () => {

    await AsyncStorage.setItem(
      'sessionData',
      "",
    )
    await AsyncStorage.setItem(
      'userData',
      "",
    )

    navigation.navigate('Home', { name: 'Jane' })
  }


  useEffect(() => {
    const func = async () => {
      let data = await AsyncStorage.getItem('sessionData')
      console.log(data);
      if (data != null){
      if (JSON.parse(data)) {
        // console.log(new Date(data["expirationDate"]));
        // console.log(new Date());
        // console.log(data);
        data = JSON.parse(data)
        if (new Date(data["expirationDate"]) < new Date()) {
          console.log("Sesión caducada");
          logout()
        } else {
          navigation.navigate('Profile')
        }
      }
    }
    }
    func()
    return function cleanup() {
    };
  }, [])


  const login = async () => {
    console.log("usuario: " + usuario);
    console.log("password: " + password);

    if (!validateNumber(usuario)) {
      return
    }

    const data = {
      "username": usuario,
      "password": password
    }

    axiosBasicInstanceApiGateway({
      method: "post",
      url:
        "/login/",
      // headers: req.headers,
      data: data,
    })
      .then(async (response) => {
        console.log(response.data);
        if (!response.data.refresh_token) {
          Alert.alert('Usuario o contraseña incorrectos', '', [
            {
              text: 'OK',
              onPress: () => console.log('OK Pressed'),
            },
          ])
          throw new Error("error")
        }
        setUsuario("")
        setPassword("")
        // expirationDate = new Date(2023, 6, 16, 16, 40, 58)
        let expirationDate = new Date()
        response.data["expirationDate"] = new Date(expirationDate.getTime() +  0.000173*86400000)//0.000173
        // response.data["expirationDate"] = new Date(expirationDate.getTime() + 72000000)
        // console.log(response.data);
        await AsyncStorage.setItem(
          'sessionData',
          JSON.stringify(response.data),
        )
      
        navigation.navigate('Profile', { name: 'Jane' })
      })
      .catch((err) => {
        console.log("axios error");
        console.log(err);
        Alert.alert('Usuario o contraseña incorrectos', '', [
          { text: 'OK', onPress: () => console.log('OK Pressed') },
        ])
        setPassword("")
      });



    // const data = {
    //   usuario: usuario,
    //   access_token: "ej",
    //   refresh_token: "ej"
    // }




  }

  const validateEmail = (text) => {
    console.log(text);
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
    if (reg.test(text) === false) {
      console.log("Email is Not Correct");
      // this.setState({ email: text })

      return false;
    }
    else {
      return true;
      // this.setState({ email: text })
      console.log("Email is Correct");
    }
  }

  const validateNumber = (text) => {
    console.log(text);
    let reg = /^\d+$/;
    if (reg.test(text) === false) {
      console.log("Usuario is Not Correct");
      // this.setState({ usuario: text })
      Alert.alert('Usuario Invalido', '', [
        { text: 'OK', onPress: () => console.log('OK Pressed') },
      ])
      return false;
    }
    else {
      return true;
      // this.setState({ usuario: text })
      console.log("Usuario is Correct");
    }
  }

  const insets = useSafeAreaInsets();
  return (
    <View
      style={[
        styles.container,
        {
          // backgroundColor: '#6a51ae',
          // marginTop: insets.top,
          // paddingTop: insets.top,
          // paddingBottom: insets.bottom,
          //   paddingLeft: insets.left,
          //   paddingRight: insets.right,
        },
      ]}
      contentContainerStyle={[
        {
          paddingTop: insets.top,
          paddingBottom: insets.bottom,
          paddingLeft: 25,
          // paddingRight: insets.right,
        }]}
    >
      <ImageBackground
        source={require('./green-background.png')}
        resizeMode="cover"
        style={styles.backgroundImage}
      >
        <View></View>
        <View>
          <Image
            style={styles.logo}
            source={require('./logoUGC.png')}
          />

          <Text style={styles.text}>Usuario:</Text>
          <TextInput
            style={styles.input}
            value={usuario}
            onChangeText={text => setUsuario(text)}
          />
          <Text style={styles.text}>Contraseña:</Text>
          {/* <TextInput
            style={styles.input}
            secureTextEntry={true}
            value={password}
            onChangeText={text => setPassword(text)}
          /> */}
          <PasswordInput
            style={styles.input}
            onValueChange={setPassword}
            value={password}
          />
          <Pressable
            style={[styles.appbutton,]}
            onPress={() =>
              
              // navigation.navigate('Profile', { name: 'Jane' })
              login()
            }
          >
            <Text
              style={[styles.buttontext,]}
            >
              Entrar
            </Text>
          </Pressable>
        </View>
        <View>
          {/* <Image
            style={styles.logo}
            source={require('./una-experiencia-de-vida.png')}
          /> */}
        </View>
      </ImageBackground>
    </View>
  );
};


const ProfileScreen = ({ navigation, route }) => {
  const insets = useSafeAreaInsets();

  const [sessionData, setSessionData] = useState({})
  const [userData, setUserData] = useState({})
  const [codeData, setCodeData] = useState({
    cargando: true
  })
  
  const getCodeUntil = useRef()

  useEffect(() => {
    console.log("useEffect get session data");
    const func = async () => {
      const data = await AsyncStorage.getItem('sessionData')
      setSessionData(JSON.parse(data))
    }
    func()
    return function cleanup() {
      setSessionData({})
    };
  }, [])

  useEffect(() => {
    // console.log(new Date(sessionData["expirationDate"]));
    // console.log(new Date());
    if (new Date(sessionData["expirationDate"]) < new Date()) {
      console.log("Sesión caducada");
      logout()
    }
  }, [])

  useEffect(() => {
    console.log("useEffect get user data");
    if (Object.keys(sessionData).length) {
      console.log("executing get user data");

      const func = async () => {
        const data = await AsyncStorage.getItem('userData')
        console.log("JSON.parse(data)");
        console.log(data)
        // console.log(JSON.parse(data));
        if (data.length == 0 ||data ==null ) {
          console.log("entre")
          getUserDataFromApi()
        }
        console.log("no es nulo es: "+ typeof(data).length)
        console.log(data.length)
        setUserData(JSON.parse(data))
      }

      func()

      const getUserDataFromApi = () => {
        console.log("fetching from api");
        if (sessionData.identity) {
          axiosTokenInstanceApiGateway({
            method: "get",
            url:
              "/usuarios/" + sessionData.identity + "/",
            // headers: req.headers,
            // data: data,
          })
            .then(async (response) => {
              console.log(response.data);
              console.log("no axios error in get data");
              setUserData(response.data)
              await AsyncStorage.setItem(
                'userData',
                JSON.stringify(response.data),
              )
              navigation.navigate('Profile', { name: 'Jane' })
            })
            .catch((err) => {
              console.log("axios error in get user data");
              console.log(err);
            });
        }
        return function cleanup() {
          setUserData({})
        };
      }
    }
  }, [sessionData])


  useEffect(() => {
    console.log("useEffect get user code");
    try {

      console.log(Object.keys(userData).length);
      if (Object.keys(userData).length) {
        console.log("executing get user code");
        resetGetCodeUntil()
      }
    } catch {
      console.log("Error in get user code");
    }
    return function cleanup() {
      setCodeData({})
    };
  }, [userData])

  const resetGetCodeUntil = () => {
    const currentTime = new Date();
    console.log("Trying to set th");
    console.log(currentTime);
    const newTime = new Date(currentTime.getTime() + 0.66 * 60000)
    console.log("Trying to set th");
    console.log(newTime);
    getCodeUntil.current = newTime
    getUserCode()
  }

  const getUserCode = () => {
    console.log("Executing get user Code function");
    if (userData) {
      const data = {}
      data["person_type"] = userData && userData.hasOwnProperty("tipopersona") ? userData.tipopersona : "ESTUDIANTE"
      // data["person_type"] = "ESTUDIANTE"
      if (sessionData.identity) {
        axiosTokenInstanceApiGateway({
          method: "post",
          url:
            "/code-request/",
          // headers: req.headers,
          data: data,
        })
          .then(async (response) => {
            console.log("no axios error");
            console.log(response.data);
            setCodeData(response.data)
            const currentTime = new Date();
            const generatedAt = new Date(response.data["generatedAt"])
            console.log(currentTime);
            console.log(generatedAt);
            console.log("elapsed time");
            console.log(currentTime.getTime() - generatedAt.getTime());
            const requestNewCodeIn = response.data["expirationTime"] - (currentTime.getTime() - generatedAt.getTime()) + 500;
            console.log("requestNewCodeIn");
            console.log(requestNewCodeIn);
            console.log(typeof (requestNewCodeIn));
            if (currentTime < getCodeUntil.current) {
              if (requestNewCodeIn < -2000) {
                console.log("Try Now");
                getUserCode()
              }
              else if (requestNewCodeIn < 0) {
                console.log("Try in half second");
                setTimeout(getUserCode, 500)
              }
              else {
                console.log("setTimeOut");
                setTimeout(getUserCode, requestNewCodeIn)
              }
              // navigation.navigate('Profile', { name: 'Jane' })
            } else {
              setCodeData({})
              getCodeUntil.current = ""
            }
          })
          .catch((err) => {
            setCodeData({})
            console.log("axios error in get user code");
            console.log(err);
            Alert.alert('Existe un problema con tu conexión a internet.', 'Por favor, verfica tu conexión y vuelve a intentar nuevamente', [
              {
                text: 'Cancelar',
                onPress: () => {},
              },
              {
                text: 'Reintentar',
                onPress: () => setTimeout(getUserCode, 500),
              },
            ])
          });
      }
    }
  }



  const logout = async () => {

    await AsyncStorage.setItem(
      'sessionData',
      "",
    )
    await AsyncStorage.setItem(
      'userData',
      "",
    )

    navigation.navigate('Home', { name: 'Jane' })
  }

  return (
    <ImageBackground
      source={require('./green-background.png')}
      resizeMode="cover"
      style={[
        styles.containerProfileScreen,
        {
          // backgroundColor: '#6a51ae',
          alignItems: "center",
          paddingTop: insets.top,
          paddingBottom: insets.bottom,
          paddingLeft: insets.left,
          paddingRight: insets.right,
        },
      ]}
    >

      <View style={styles.wrappContent}>

        <View>
          <Image
            style={styles.logo}
            source={require('./logoUGC.png')}
          />
        </View>

        {/* <View style={styles.wrappQR}> */}
        <View
          style={{
            backgroundColor: "#FFFFFF",
            opacity: 0.78,
            padding: 25,
            borderRadius: 18,
          }}
        >
          <Text
            style={{
              textAlign: "center",
              color: "#00460F",
              fontSize: SCREEN_HEIGHT / 38,
              fontWeight: "bold",
            }}
          >
            {userData && userData.hasOwnProperty("nombres") ? userData.nombres : ""} {userData && userData.hasOwnProperty("apellidos") ? userData.apellidos : ""}
          </Text>
          <Text
            style={{
              textAlign: "center",
              color: "black",
              fontSize: SCREEN_HEIGHT / 38,
              fontWeight: "bold",
            }}
          >
            {sessionData.identity}
          </Text>
          {/* <Text style={{ textAlign: "center" }}>CC.10338125463</Text> */}
          {/* <Text>This is {route.params.name}'s profile</Text> */}
        </View>
        <View
          style={{
            // flex: 1,
            backgroundColor: "#fff",
            // backgroundColor: "red",
            padding: "4%",
            // width: "fitContent",
            alignItems: "center",
          }}
        >
          {codeData && codeData.hasOwnProperty("code") ?
            <QRCode
              // value="1010074595&ghJ34l"
              value={codeData.code}
              size={175}
              style={{}}
            />
            :
            <View
              style={[
                // styles.container,
                {
                  padding: 10,
                  flex: 1,
                  maxHeight: 120,
                  justifyContent: 'space-between'
                }
              ]}
            >
              <Text
                style={{
                  textAlign: "center",
                  color: "black",
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                {/* {sessionData.identity} */}
                Código de acceso
              </Text>
              <Pressable
                title="Generar"
                style={[styles.appbutton,]}
                onPress={() => {
                  
                  resetGetCodeUntil()
                  // navigation.navigate('Profile', { name: 'Jane' })
                }
                }
              >
                <Text
                  style={[styles.buttontext,]}
                >
                  Generar
                </Text>
              </Pressable>
            </View>
          }


        </View>
        <View>

          <Text
            style={{
              textAlign: "center",
              color: "#9f1",
              fontSize: 22,
              fontWeight: "bold",
            }}
          >
            {/* ADMINISTRATIVO */}
            {userData && userData.hasOwnProperty("tipopersona") ? userData.tipopersona : ""}

          </Text>
          <Text
            style={{
              textAlign: "center",
              color: "white",
              fontSize: 14,
              fontWeight: "bold",
            }}
          >
            {/* ADMINISTRATIVO */}
            {userData && userData.hasOwnProperty("dependencia_programa") ? userData.dependencia_programa : ""}

          </Text>
        </View>
        {/* </View> */}

        <View style={{
          alignItems: "flex-start",
          width: "100%",
          padding: 30
        }}
        >
           <Pressable
           
            onPress={() =>
              
              // navigation.navigate('Profile', { name: 'Jane' })
              logout()
            }
          >
            <Svg
            width={70}
            height={70}
            viewBox="0 0 66 68"
            onPress={() =>
              // navigation.navigate('Home')
              
              logout()
            }
          >
            <Path d="M0.182129 33.5635C0.182129 15.4716 14.8485 0.805176 32.9404 0.805176V0.805176C51.0324 0.805176 65.6988 15.4716 65.6988 33.5635V34.6405C65.6988 52.7324 51.0324 67.3988 32.9404 67.3988V67.3988C14.8485 67.3988 0.182129 52.7324 0.182129 34.6405V33.5635Z" fill="#D3FFD5" />
            <Path fill-rule="evenodd" clip-rule="evenodd" d="M43.4574 22.1761L23.0352 22.1761L23.0352 17.0706L43.4574 17.0706C46.2772 17.0706 48.563 19.3564 48.563 22.1761L48.563 47.7039C48.563 50.5237 46.2771 52.8095 43.4574 52.8095L23.0352 52.8095L23.0352 47.7039L43.4574 47.7039L43.4574 22.1761Z" fill="black" />
            <Path fill-rule="evenodd" clip-rule="evenodd" d="M23.6269 25.6475L27.5491 28.916L22.529 34.9401L27.5491 40.9642L23.6269 44.2327L15.883 34.9401L23.6269 25.6475Z" fill="black" />
            <Path fill-rule="evenodd" clip-rule="evenodd" d="M17.9296 32.3872L33.2463 32.3872L33.2463 37.4928L17.9296 37.4928L17.9296 32.3872Z" fill="black" />
          </Svg>
          </Pressable>
          
        </View>

      </View>

    </ImageBackground>
  )
};


export default function App() {
  return (
    <SafeAreaProvider>
      <StatusBar
        // animated={true}
        // backgroundColor="#00460f"
        // backgroundColor="#2435ac"
        // barStyle='dark'
        style={"light"}
      // showHideTransition={statusBarTransition}
      // hidden={hidden}
      />
      <NavigationContainer>
        {/* <Stack.Navigator initialRouteName="Home"> */}
        <Stack.Navigator initialRouteName="Home" screenOptions={{ headerShown: false }}>
          <Stack.Screen
            name='Home'
            component={HomeScreen}
            options={{
              // title: 'My home',
              // headerStyle: {
              //   backgroundColor: '#00913D',
              // },
              // headerTintColor: '#fff',
              // headerTitleStyle: {
              //   fontWeight: 'bold',
              // },
            }}
          />
          <Stack.Screen
            name='Profile'
            component={ProfileScreen}
            options={{ title: 'Otra pestaña' }}

          />
        </Stack.Navigator>
      </NavigationContainer>
    </SafeAreaProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#00460f',
    // alignItems: 'center',
    justifyContent: 'center',
    // paddingHorizontal: 25,
  },
  containerProfileScreen: {
    flex: 2,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  input: {
    height: 40,
    marginTop: 12,
    marginBottom: 12,
    borderWidth: 1,
    padding: 10,
    backgroundColor: '#fff',
  },
  text: {
    color: '#fff',
    textAlign: 'center',
  },
  appbutton: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 32,
    borderRadius: 4,
    elevation: 3,
    backgroundColor: 'black',
  },
  buttontext: {
    fontSize: 16,
    lineHeight: 21,
    fontWeight: 'bold',
    letterSpacing: 0.25,
    color: 'white',
  },
  backgroundImage: {
    flex: 1,
    paddingRight: 25,
    paddingLeft: 25,
    // width: "100%",
    // height: "100%",
    justifyContent: 'space-between',
    alignItems: "center",

  },
  wrappContent: {
    width: "100%",
    height: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logo: {
    // justifyContent: 'center',
    // alignItems: 'center',
    width: '100%',
    // width: 60,
    height: undefined,
    aspectRatio: 6 / 1,    // justifySelf: "flex-end"
  },
  exit: {
    width: 20,
    height: 20,
  },
  wrappQR: {
    // backgroundColor: "blue",
    height: 400,
    justifyContent: 'space-between',
  },
});
